import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable"
import CustomModal from "../thema/tema1/component/CustomModal"
import axios from 'axios';
import jsPDF from "jspdf";

const tur = 1;

const active = { gemiyuklendihepsi: "active" };
const durumlar = {
    1: "Araç Limana Giriş Yaptı",
    2: "Ek Bilgi Girişi Yapıldı",
    3: "Ücret Belirlendi",
    4: "Ücret Alındı",
    5: "Gemiye Yüklendi",
    6: "Muhasebe İşlmei Tamamlandı",
};
const gidecegiUlkeEnum = {
    0: "BELİRLENMEDİ",
    1: "TRİESTE",
    2: "BARİ",
};
class GemiYuklendiHepsi extends React.Component {
    componentDidMount() {
    }
    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            plaka: "",
            baslangic: "",
            bitis: "",
            firmaId: 0,
            dorsePlaka: "",
            cekiciPlaka: "",
            tarih: "",
            firmalar: [],
            tasimalar: [],
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            makbuzId: 0,
            makbuzDurum: 0,
            silModal: 'none',
            title: ["STATU - TT NUMARASI","TARİH","ÇEKİCİ PLAKA","DORSE PLAKA","GİDECEĞİ ÜLKE", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.firmalarDoldur();
        this.handlePageClickAra({selected:0});
        this.getTotalRow();
    }
    firmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/firma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let firmalar = res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>);
                this.setState({ firmalar: firmalar });
            })
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    setSil = (e)=>{
        this.setState({silId:e.id});
    }
    setDuzenle = (e)=>{
        this.setState({dorsePlaka:e.dorsePlaka});
        this.setState({cekiciPlaka:e.cekiciPlaka});
        this.setState({firmaId:e.firmaId});
        this.setState({tarih:e.tarih});
        this.setState({duzenleId:e.id});
        this.setState({showDuzenle:true});
    }
    geri = (e)=>{
        this.setState({dorsePlaka:""});
        this.setState({cekiciPlaka:""});
        this.setState({firmaId:0});
        this.setState({tarih:""});
        this.setState({showDuzenle:false});
    }
    silModal = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/delete/'+this.state.silId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.getTotalRow();
                this.handlePageClick({selected:0});
                window.successful("Taşıma Silindi");
                this.setState({dorsePlaka:""});
                this.setState({cekiciPlaka:""});
                this.setState({firmaId:0});
                this.setState({tarih:""});
            }).catch(res =>{
            window.unsuccessful("Taşıma Silinemedi.");
        });
        window.disableModal();
    }
    getTotalRow = (e)=>{
        axios({
            method: 'post',
            url: Properties.baseUrl+'/tasima/sayfaliGetirArsivHepsiToplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            },
            data:{
                plaka: this.state.plaka.toUpperCase().replace(/\s/g, ''),
                bitis:this.state.bitis,
                baslangic:this.state.baslangic
            }
        })
            .then(res => {
                if(res.data < 10)
                {
                    this.setState({ endRow:res.data});
                }
                if(e != undefined ){
                    if( e.selected == undefined)
                    {
                        if(res.data > 10)
                        {
                            this.setState({ endRow:10});
                        }
                        else
                        {
                            this.setState({ endRow:res.data});
                        }
                        this.setState({ startRow: 0});
                    }
                    else {
                        this.setState({ startRow: (e.selected*10)+1});
                        this.setState({ endRow:((e.selected+1)*10)});
                    }
                }

                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/sayfaliGetirArsivHepsi/'+e.selected,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.cekiciPlaka = eleman.cekiciPlaka;
                    elemanIc.dorsePlaka = eleman.dorsePlaka;
                    elemanIc.gidecegiUlke = eleman.gidecegiUlke;
                    elemanIc.tarih = eleman.tarih;
                    elemanIc.ttNumarasi = eleman.ttNumarasi;
                    getData.push(eleman);
                });
                this.setState({tasimalar:getData});

                let content = getData.map((item) =>
                    (<tr>
                        <td>{durumlar[item.durum] + (item.ttNumarasi?(" - "+item.ttNumarasi):"")}</td>
                        <td>{item.tarih}</td>
                        <td>{item.cekiciPlaka}</td>
                        <td>{item.dorsePlaka}</td>
                        <td>{gidecegiUlkeEnum[item.gidecegiUlke]}</td>
                        <td>
                            <button  type="button" onClick={e => this.goruntule(item.id)}
                                     className="btn btn-block btn-outline-info">GÖRÜNTÜLE
                            </button>
                        </td>
                    </tr>));
                this.setState({content:content});
            });
    }

    handlePageClickAra=e=>{
        this.getTotalRow(e);


        axios({
            method: 'POST',
            url: Properties.baseUrl+'/tasima/sayfaliGetirArsivHepsi',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            },
            data:{
                id:e.selected,
                plaka: this.state.plaka.toUpperCase().replace(/\s/g, ''),
                bitis:this.state.bitis,
                baslangic:this.state.baslangic
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.cekiciPlaka = eleman.cekiciPlaka;
                    elemanIc.dorsePlaka = eleman.dorsePlaka;
                    elemanIc.gidecegiUlke = eleman.gidecegiUlke;
                    elemanIc.tarih = eleman.tarih;
                    elemanIc.ttNumarasi = eleman.ttNumarasi;
                    getData.push(eleman);
                });
                var color = {}
                var change = 0;
                res.data.forEach(function (eleman) {
                    if(color[eleman.tarih.split(" ")] == undefined)
                    {
                        if(change == 0)
                        {
                            color[eleman.tarih.split(" ")] = "#ffffff";
                        }
                        else{
                            color[eleman.tarih.split(" ")] = "#c4e1ff";
                        }
                        change += 1;
                    }
                });
                this.setState({tasimalar:getData});
                let content = getData.map((item) =>
                    (<tr style={{"background-color":color[item.tarih.split(" ")]}}>
                        <td>{durumlar[item.durum] + (item.ttNumarasi?(" - "+item.ttNumarasi):"")}</td>
                        <td>{item.tarih}</td>
                        <td>{item.cekiciPlaka}</td>
                        <td>{item.dorsePlaka}</td>
                        <td>{gidecegiUlkeEnum[item.gidecegiUlke]}</td>
                        <td>
                            <div className="row">
                                <div className="col-4">
                                    <button type="button" onClick={e => this.goruntule(item.id)}
                                            className="btn btn-block btn-outline-info">GÖRÜNTÜLE
                                    </button>
                                </div>
                                <div className="col-4">
                                    <button type="button"
                                            className="btn btn-block btn-outline-primary"
                                            onClick={e => this.durumGuncelle(item.id, 4)}
                                            data-toggle="modal" data-target="#modal-default">GERİ AL
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>));
                this.setState({content: content});
            });
    }


    ucretBelirle = (e) => {
        window.location = '/ucretbelirle/' + e;
    }
    goruntule = (e) => {
        window.location = '/goruntule/' + e;
    }
    durumGuncelle = (id, durum) => {
        this.setState({makbuzId: id});
        this.setState({makbuzDurum: durum});
    }
    bilgiGiris = (e) => {
        window.location = '/bilgigiris/' + e;
    }
    ekOdeme = (e) => {
        window.location = '/ekodeme/' + e;
    }
    gemiYukle = () => {
        window.disableModal();
        axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                this.handlePageClickAra({selected:0});
                window.successful((this.state.showDuzenle?"Gemi Yükleme Güncellendi.":"Gemi Yükleme Kaydedildi"));
            }).catch(res =>{
            window.unsuccessful((this.state.showDuzenle?"Gemi Yükleme Güncellenemedi.":"Gemi Yükleme Kaydedilemedi."));
        });
    }
    makbuzYazdir = (e) => {
        const doc = new jsPDF();
        doc.text("GEMİ ÜCRETİ 100 €", 10, 10);
        doc.text("BAF 10 €", 10, 10);
        doc.text("FOKLİFT 10 €", 10, 20);
        doc.save("myPDF.pdf");
        window.disableModal();
        axios({
            method: 'post',
            url:  Properties.baseUrl+'/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                this.handlePageClickAra({selected:0});
                window.successful((this.state.showDuzenle?"Makbuz Güncellendi.":"Makbuz Kaydedildi"));
            }).catch(res =>{
            window.unsuccessful((this.state.showDuzenle?"Makbuz Güncellenemedi.":"Makbuz Kaydedilemedi."));
        });
        this.handlePageClickAra({selected:0});
        this.getTotalRow();
    }
    onClick = (e) => {
        window.inputmaskReady();
    }

    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header />
                <SideMenu gemiyuklendihepsi="active"  gemiyuklendi="menu-is-opening menu-open" gemiyuklendiacik={{display:'Block'}}      />
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title"
                                    style={this.state.showDuzenle ? {display: 'none'} : {display: 'block'}}>Filtre</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Başlangıç Tarihi</label>
                                        <input onClick={this.onClick} onKeyUp={this.onChange} type="text" name="baslangic"
                                               value={this.state.baslangic} className="form-control"
                                               data-inputmask-alias="datetime"
                                               data-inputmask-inputformat="dd/mm/yyyy HH:MM" data-mask/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Bitiş Tarihi</label>
                                        <input onClick={this.onClick} onKeyUp={this.onChange} type="text" name="bitis"
                                               value={this.state.bitis} className="form-control"
                                               data-inputmask-alias="datetime"
                                               data-inputmask-inputformat="dd/mm/yyyy HH:MM" data-mask/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Plaka</label>

                                        <input type="text" value={this.state.plaka} className="form-control"
                                               name="plaka" onChange={this.onChange}
                                               placeholder="Plaka"/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1"></label>

                                        <button onClick={this.handlePageClickAra}
                                                style={this.state.showDuzenle ? {display: 'none'} : {
                                                    margin: "10px",
                                                    display: 'block'
                                                }} type="button" className="btn btn-primary">Ara
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                    <div className="card">
                        <div className="card-body">
                            <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                         handlePageClick={this.handlePageClickAra}></CustomTable>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.gemiYukle} title={"İptal Etme"}
                             content={"İptal Edilsin mi?"}></CustomModal>
                <CustomModal id={"makbuz-modal"} funcModal={this.makbuzYazdir} title={"Makbuz Çıktı"}
                             content={"Makbuz Çıktı Alınsın mi?"}></CustomModal>
                <CustomModal id={"sil-modal"} funcModal={this.silModal} title={"Taşıma Silme"}
                             content={"Taşıma Silinsin mi?"}></CustomModal>
            </div>);
    }
}


export default GemiYuklendiHepsi;
